<template>
	<div class="footer">
    <div  class="flex-center footer_top">
       <div class="flex-col align-start ">
         <span>全国统一服务热线</span>
         <span class="mt10">服务时间：8:00-21:00</span>
       </div>
      <div class="sep-line-v"></div>
      <div><a :href="'tel:400-900-6896'" style="font-size: 40px;color: #535353;font-family: Microsoft YaHei">400-900-6896</a></div>
    </div>
		<div class="flex-center footer_bottom" style="gap: 20px">
      <p class="footer_about">
        <router-link v-for="item in data.aboutItem" :key="item" :to="item.link">{{ item.name }}</router-link>
      </p>
      <p>版权所有：北京中盛佳源教育科技有限公司</p>
      <p class="footer_link">
        <a href="http://beian.miit.gov.cn">京ICP备15052609号-2</a>
      </p>
      <p class="flex">
        <img src="https://img.alicdn.com/tfs/TB13DzOjXP7gK0jSZFjXXc5aXXa-212-48.png" style="width: 70px; margin-right: 10px;">
        提供计算与安全服务
      </p>
    </div>
	</div>
</template>

<script lang="ts" setup>
import {reactive} from 'vue';

const data: any = reactive({
	aboutItem: [
		{
			'name': '加入我们',
			'link': '/666',
		},
		{
			'name': '关于我们',
			'link': '/777',
		},
		{
			'name': '联系我们',
			'link': '/888',
		},
	],
});
</script>
<style scoped lang="scss">
.footer {
	text-align: center;

	min-width: 1024px;
	box-sizing: border-box;
	
	p {
		color: #fdfafa;
		font-size: 16px;
		
		a {
			color: #fdfafa;
		}
	}
	
	.footer_about {
		margin-bottom: 20px;
		display: none;
	}
	
	.footer_about a {
		border-right: 1px solid #fdfafa;
		padding: 0 10px;
	}
	
	.footer_about a:last-child {
		border-right: none;
	}
  .footer_top{
    padding: 30px 0;
    background: #f9f9f9;
    gap: 20px;
  }
	.footer_bottom{
    background-color: rgb(68, 142, 237);
    padding: 20px 0 ;
  }
  .sep-line-v {
    height: 35px;
    width: 1px;
    background: #ccc;
    position: relative;
    top: 4px;
  }
}

</style>